import { render } from "./Trading.vue?vue&type=template&id=7f816f8a&scoped=true"
import script from "./Trading.vue?vue&type=script&lang=js"
export * from "./Trading.vue?vue&type=script&lang=js"

import "./Trading.vue?vue&type=style&index=0&id=7f816f8a&lang=scss&scoped=true"

import exportComponent from "G:\\Programming\\VueProjects\\radinrealp2p\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f816f8a"]])

export default __exports__